<template>
      <section class="hero">
        <div class="hero-body">
            <div class="container has-text-centered">
                <div class="column is-4 is-offset-4">
                    <div class="box" style="margin-top:10vh;">
                        <p>Redirecting...</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

    export default {
        name: 'Mobile',
        mounted() {
            const vm = this;
            this.$store.dispatch('routeLoading');
            this.$nextTick(function() {
                let nextUrl = process.env.STORMPORT_MOBILE_APP_URL;
                nextUrl = nextUrl.indexOf('?') < 0 ? nextUrl + '?' : nextUrl + '&';
                nextUrl = `${nextUrl}start_route=1&token=${encodeURIComponent(vm.authToken)}`;
                window.location.replace(nextUrl);
            })
        },
        computed: {
            authToken() {
                return this.$store.state.Auth.token;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/pages/Mobile/index.vue